<template>
    <div class="oddBox show-option">
        <div
            v-bind:class="[
                'odd',
                'JARVIS_MatchCard_Btn_Odds',
                {
                    odd_rise: oddRise,
                    odd_drop: oddDrop,
                    odd_selected: isOddsSelected,
                    odd_locked: isOddsSuspended,
                },
            ]"
            v-bind:market-type-data-list="marketOrder"
            v-bind:data-match="gaDataMatch"
            v-bind:match-card-data-list="matchInfo.matchOrder"
            v-on:click="onClickOdds"
        >
            <div v-if="!isOddsSuspended" class="odd-option fMarket-goalNoGoal">
                <span class="_optionName">{{ optionNameDisplay }}</span>
            </div>
            <div v-if="!isOddsSuspended" class="odd-middle-gap" />

            <div v-if="!isOddsSuspended" class="odd-wrapper">
                <div class="odd-align-left-wrapper">
                    <div
                        class="odd-value"
                        v-bind:class="{ _negative: isOddsNegative, rtl: isReverseDisplayOddsEnabled }"
                    >
                        {{ strReverse(formatMinDecimalPlace(priceOption.price, minimumDecimalPlace), isReverseDisplayOddsEnabled) }}
                    </div>
                </div>
            </div>

            <div v-if="isOddsSuspended" class="odd-locked">
                <SvgIcon iconName="systemIcon_Locked" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { computed, defineComponent, ref, toRefs } from 'vue';
    import type { IMatch } from '@/interface/IMatch';
    import type { IOdds, IPriceOption } from '@/interface/IOdds';
    import { DisplaySection } from '@/interface/enum';
    import useOddsDisplay from '@/libraries/composables/useOddsDisplay';
    import { i18n } from '@/libraries/i18n';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'FastMarketOdds',
        components: {
            SvgIcon,
        },
        props: {
            matchInfo: {
                type: Object as PropType<IMatch>,
                required: true,
            },
            oddsInfo: {
                type: Object as PropType<IOdds>,
                required: true,
            },
            priceOption: {
                type: Object as PropType<IPriceOption>,
                required: true,
            },
            displaySection: {
                type: Number as PropType<DisplaySection>,
                default: DisplaySection.Unknown,
            },
            marketOrder: {
                type: Number,
                default: -1,
            },
            isEuroSiteStyle: {
                type: Boolean,
                default: false,
            },
        },
        setup(props) {
            const optionNameDisplay = computed(() => i18n.t(props.priceOption.optionName));

            const { matchInfo, oddsInfo, priceOption, displaySection } = toRefs(props);
            const oddsComponent = ref<HTMLElement | null>(null);

            const {
                oddRise,
                oddDrop,
                isOddsNegative,
                isOddsSuspended,
                isOddsSelected,
                point,
                minimumDecimalPlace,
                gaDataMatch,
                toFixedDecimalPoint,
                onClickOdds,
                formatMinDecimalPlace,
                strReverse,
                isReverseDisplayOddsEnabled,
            } = useOddsDisplay({
                matchInfo,
                oddsInfo,
                priceOption,
                displaySection,
                oddsComponentRef: oddsComponent,
            });

            return {
                optionNameDisplay,
                oddRise,
                oddDrop,
                isOddsNegative,
                isOddsSuspended,
                isOddsSelected,
                point,
                minimumDecimalPlace,
                gaDataMatch,
                toFixedDecimalPoint,
                onClickOdds,
                formatMinDecimalPlace,
                strReverse,
                isReverseDisplayOddsEnabled,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/odd";
</style>

<style>
.fMarket-goalNoGoal {
    margin-left: 0.5em !important;
    text-align: left !important;
}

._optionName {
    width: 121%;
}
</style>
